import clsx from 'clsx';
import React from 'react';

import ClickAwayListener, { ClickAwayListenerProps } from '@material-ui/core/ClickAwayListener';
import Popper, { PopperPlacementType, PopperProps } from '@material-ui/core/Popper';

import { useStyles } from './styles';

export type ComponentProps = {
	id: string;
	anchor: PopperProps['anchorEl'];
	children: React.ReactNode;
	TransitionComponent?: React.ElementType;
	transitionProps?: any;
	backgroundColor?: string;
	className?: string;
	placement?: PopperPlacementType;
	popperProps?: Partial<Omit<PopperProps, 'placement' | 'id' | 'anchor' | 'modifiers' | 'className' | 'transition'>>;
	onClickAway?: ClickAwayListenerProps['onClickAway'];
	contentClasses?: string[];
};

const CustomPopper = (props: ComponentProps) => {
	const { id, anchor, className, children, placement, popperProps, backgroundColor, TransitionComponent, transitionProps, contentClasses } = props;
	const { onClickAway } = props;

	const classes = useStyles({ color: backgroundColor || 'white' });

	const [arrowRef, setArrowRef] = React.useState<any>();
	const handleArrowRef = React.useCallback(node => setArrowRef(node), []);

	const popperContent = React.useMemo(() => {
		const content = <div className={clsx([classes.popperContent, ...(contentClasses || [])])}>{children}</div>;
		return (
			<>
				<div className={clsx('arrow', classes.arrow)} ref={handleArrowRef}></div>
				{onClickAway ? <ClickAwayListener onClickAway={ev => onClickAway(ev)}>{content}</ClickAwayListener> : content}
			</>
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [children, handleArrowRef, onClickAway]);

	return (
		<Popper
			id={id}
			className={clsx(classes.popper, className)}
			anchorEl={anchor}
			open={!!anchor}
			modifiers={{
				flip: {
					enabled: true
				},
				arrow: {
					enabled: true,
					element: arrowRef
				}
			}}
			placement={placement || 'bottom-start'}
			transition={!!TransitionComponent}
			{...popperProps}
		>
			{({ TransitionProps }) => {
				if (!!TransitionComponent)
					return (
						<TransitionComponent {...TransitionProps} {...transitionProps}>
							{popperContent}
						</TransitionComponent>
					);
				else return popperContent;
			}}
		</Popper>
	);
};

export default React.memo(CustomPopper);
